/**
 * QueryClient compartilhado (React Query) — exigido por API-CACHE-01.
 *
 * Retry fica desligado aqui porque o interceptor do axios (lib/api.ts) já faz
 * retry com backoff em 5xx/erro de rede — evita retry duplicado. 4xx nunca
 * deve repetir (API-RETRY-01).
 */

import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
})
